<template>
  <div class="login">
    <div class="row">
      <div class="col announce-sec">
        <!-- <span class="title">NEW ENGAGEMENT FEATURE</span><br>
        <span class="subtitle">B1G1’s most exciting update ever</span><br><br>
        <span class="subtitle"><a href="https://blog.b1g1.com/b1g1-engagement-tool/"
                                  style="color: white;text-decoration:underline !important;" target="_blank">Learn more here </a></span> -->
      </div>
      <div class=" col content">
        <div class="login-form-sec">
          <div class="logo">
            <a href="https://www.b1g1.com">
              <link rel="stylesheet" media="all" type="text/css" href="/static/front/font_css.css">
              <img src="/static/logos/logo.png" class="logo-default" alt="alt">
            </a>
          </div>
          <div class="login-content">
            <form v-if="step === 1">
              <div class="alert alert-danger" role="alert"
                   v-if="!passErrValid && display.login_error">{{ display.login_error }}
              </div>
              <div class="alert alert-success" role="alert"
                   v-if="passErrValid && display.login_error">{{ display.login_error }}
              </div>
              <div class="form-group" :class="{'has-error': errors.has('email') }">
                <label class="control-label visible-ie8 visible-ie9">Username</label>
                <div class="input-icon">
                  <input type="email" ref="email" name="email" placeholder="Email" v-model="form.username"
                         v-validate="'required|email'" :class="'form-control' + (getError('email') ? ' txterror' : '')"
                         @keypress="entSub(form)">
                </div>
                <span v-if="errors.has('email') && form.username" class="error">Please enter a valid email address.</span>
              </div>
              <div class="form-group" :class="{'has-error': errors.has('password') }">
                <label class="control-label visible-ie8 visible-ie9">Password</label>
                <div class="input-icon">
                  <input type="password" ref="password" name="password" placeholder="Password" v-model="form.password"
                         v-validate="'required'" :class="'form-control' + (getError('password') ? ' txterror' : '')"
                         @keypress="entSub(form)">
                </div>
              </div>
              <div class="form-actions">
                <button type="button" class="b-btn red-btn" @click="loginAction" :disabled="errors.count() > 0 || waiting==true">Login
                </button>
              </div>
              <div class="row">
                <div class="dont-sec">
                  <p>Don't have an account?<br><a href="https://www.b1g1.com/businessforgood">Click here</a> to find out
                    more about B1G1.</p>
                </div>
              </div>
              <div class="forget-password">
                <p class="m-0"><a style="cursor:pointer" @click="showForget()">Forgot your password ?</a></p>
              </div>
            </form>
            <form v-if="step === 2">
              <div class="alert alert-danger" role="alert" v-if="display.error">{{ display.error }}</div>
              <h5 class="form-title">FORGOT YOUR PASSWORD ?</h5>
              <p>Enter the email that is registered to your account below to reset your password.</p>
              <div class="form-group">
                <div class="input-icon">
                  <input type="email" ref="email" name="email" v-model="form.username" v-validate="'required|email'"
                         class="form-control" placeholder="Email">
                </div>
                <span v-if="errors.count() >0" class="text-danger" style="margin-top: 15px;">Please enter a valid email address.</span>
              </div>
              <div class="form-actions f-btn">
                <a @click="hideForget" class="white-btn float-left">Go to Login </a>
                <button type="button" class="b-btn red-btn" @click="forgetAction()"
                        :disabled="errors.count() >0 || waiting==true">Submit
                </button>
              </div>
              <h6 v-if="display.success" style="margin-top: 20px; font-weight:bold;"><i
                class="fa fa-check"></i> {{ display.success }}</h6>
            </form>
          </div>
          <div class="copyright">B1G1 © {{ new Date().getFullYear() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import router from '../router'
import userAPI from '../api/user'
import config from '../config/app'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Cookie from 'vue-js-cookie'

Vue.use(VeeValidate)
Vue.use(Cookie)
export default {
  name: 'login',
  data: () => {
    return {
      form: {
        username: Cookie.get('username') ? Cookie.get('username') : null,
        password: null
      },
      waiting: false,
      step: 1,
      display: {
        login_error: '',
        error: '',
        success: ''
      },
      intYear: new Date().getFullYear(),
      passErrValid: false
    }
  },
  created: () => {
    let param = store.getters.currentUser
    if (param != null) {
      router.push('/impact')
    }
  },
  methods: {
    getError (name) {
      return this.errors.items.filter(i => i.field === name).length > 0
    },
    loginAction () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        Cookie.set('username', this.form.username)
        this.waiting = true
        if (localStorage.getItem('fp_token')) {
          localStorage.removeItem('fp_token')
        }
        this.$store.dispatch('login', this.form).then(() => {
          this.saveUserLogin(this.form.username, this.form.password)
        }, () => {
          this.waiting = false
          this.display.login_error = 'Wrong credentials'
        })
      })
    },
    entSub (form) {
      if (window.event && window.event.which === 13) {
        this.loginAction()
      } else {
        return true
      }
    },
    saveUserLogin (username, password) {
      let reloadUrl = localStorage.getItem('b1g1_reload_url')
      userAPI.saveUserLogin(username).then((response) => {
        this.waiting = false
        if (response.status === 'error') {
          this.display.login_error = response.error_msg
          this.$store.dispatch('logout')
        } else {
          if (response.user_type === 'business') {
            localStorage.setItem('b1g1_reload_url', '')
            if (reloadUrl === '' || reloadUrl === null) {
              let segments = window.location.pathname.split('/')
              if (segments[1] === 'login' || segments[1] === 'businessforgood') {
                location.href = config.host + '/impact'
              } else {
                window.location.reload()
              }
            } else {
              location.href = reloadUrl
            }
          } else if (response.user_type === 'partner') {
            localStorage.removeItem('login_user_type')
            location.href = config.host + '/'
          } else {
            if (response.user_type === 'admin') {
              localStorage.setItem('login_user_type', 'admin')
              localStorage.setItem('YUJAqQWVZTRRJsvPpKIG', btoa(username))
              localStorage.setItem('VxdqRJrxxGTZSSwFmmOU', btoa(password))
              localStorage.setItem('b1g1_reload_url', '')
            }
            location.href = config.host + '/'
          }
        }
      }, () => {
        this.waiting = false
      })
    },
    showForget () {
      this.step = 2
    },
    hideForget () {
      this.step = 1
    },
    forgetAction () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.waiting = true
        userAPI.resetPassword(this.form.username).then((response) => {
          if (response.error) {
            this.waiting = false
            this.step = 2
            this.passErrValid = false
            this.display.success = ''
            if (response.error === '1') {
              this.display.error = 'An error has occurred. Please reach out to us at hello@b1g1.com and we\'ll get you sorted.'
            } else if (response.error === '2') {
              this.display.error = 'This account has been suspended. Please reach out to team@b1g1.com for help with your account.'
            }
          } else {
            this.waiting = false
            this.step = 2
            this.passErrValid = true
            this.display.success = 'A link to reset your password has been sent to your email address.'
            this.display.error = ''
          }
        }, () => {
          this.waiting = false
          this.step = 2
          this.display.success = ''
          this.display.error = 'Email does not exists.'
        })
      })
      return true
    }
  },
  mounted () {
    let fpToken = localStorage.getItem('fp_token')
    if (fpToken) {
      this.display.login_error = 'The password reset link has expired. Please request another one to reset your password.'
      localStorage.removeItem('fp_token')
    }
    if (!Cookie.get('username')) {
      this.$refs.email.focus()
    } else {
      this.$refs.password.focus()
    }
  }
}
</script>

<style scoped>
/*@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css";*/
body {
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-size: 14px;
  font-weight: 300;
}

a {
  text-decoration: none !important;
  font-family: 'Brandon Grotesque';
  font-style: normal;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Brandon Grotesque';
  letter-spacing: 1.2px;
}

.login {
  height: 100%;
  min-height: 100vh;
  position: relative;
}
.login:after {
    content: "";
    height: 100%;
    min-height: 100vh;
    background-image: url(/static/front/images/Campaign-background-image-v2.jpg);
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    z-index: -1;
}
.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.login .logo {
  margin: 0 auto;
  text-align: center;
  padding: 5px 35px;
  left: 50%;
}

.logo-default {
  width: 150px;
}

.login .content {
  background: #47BFEE;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login .login-content {
  background: #FFFFFF;
  box-shadow: 0px 20px 53px rgba(0, 0, 0, 0.28);
  margin: 0 auto;
  padding: 18px;
  width: 350px;
}

.login-content form {
  padding: 12px;
}

.form-actions {
  text-align: right !important;
}

.login .copyright {
  text-align: center;
  margin: 35px 0px;
  color: #FFFFFF;
  font-size: 14px;
}

.login .content span.error {
  color: #b94a48;
}

.forget-password a {
  color: #47BFEE;
  text-decoration: underline !important;
}

.login-content [type="email"], .login-content [type="password"] {
  border: 1px solid #000000;
  height: 35px;
  width: 100%;
  padding: 0px 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 0;
  font-size: 14px;
}

.login-content label {
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 0px;
}

.dont-sec {
  padding-top: 20px;
}

.login-content h5 {
  font-size: 18px;
  text-align: center;
  margin-bottom: 19px;
}

.form-actions.f-btn {
  margin-top: 20px !important;
}

.red-btn {
  background: #FF1254;
  border-radius: 3px !important;
}

.b-btn {
  color: #fff;
  padding: 5px 14px;
  display: inline-block;
  font-weight: 600;
  text-transform: uppercase;
  border: 0;
  font-size: 14px;
  cursor: pointer;
}

.white-btn {
  padding: 5px 14px;
  display: inline-block;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #ddd;
  color: #000000;
  background: #fff;
  cursor: pointer;
  border-radius: 3px !important;
}

.white-btn:hover {
  border: 1px solid #000000;
  color: #fff !important;
  background: #000000;
}

.txterror {
  border: 1px solid red !important;
}

.btn, button {
  border-radius: 0 !important;
}

.announce-sec {
  margin: auto;
  text-align: center;
}

.title {
  color: white;
  font-size: 1.82em;
  font-family: 'Brandon Grotesque';
  letter-spacing: 1.2px;
}

.subtitle {
  font-family: 'Brandon Grotesque';
  font-weight: lighter;
}

.subtitle {
  color: white;
  font-size: 1.5em;
  letter-spacing: 1.2px;
}

@media screen and (max-width: 1000px) {

  .announce-sec {
    display: none;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue